import { Button, Card, Input } from "antd";
import { ColumnsType } from "antd/es/table";
import { capitalize } from "lodash";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/store";
import PayrollDisFileIcon from "../../../assets/icons/PayrollDisFileIcon";
import PayrollImportOutlined from "../../../assets/icons/PayrollImportOutlined";
import SearchIcon from "../../../assets/icons/SearchIcon";
// import AvatarImage from "../../../assets/images/avatar-image.png";
// import BalanceSlide from "../../../components/common/BalanceSlide";
import { useParams } from "react-router-dom";
import { toast as toastMessage } from "react-toastify";
import CustomTable from "../../../components/ui/CustomTable";
import {
  useDisbursementsPaymentCheckerMutation,
  useDisbursementsPaymentWithOtpMutation,
  useGetAllDisbursementsQuery,
  useGetSalaryAmountQuery,
} from "../../../features/portal/disbursementPayment/disbursementPaymentApi";
import PinVerifyModal from "../../../features/portal/vendorPayment/PinVerifyModal";
import { useCheckSalaryDisbursementQuery } from "../../../features/portal/vendorPayment/vendorPaymentApi";
import useDebounce from "../../../hooks/useDebounce";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import ConfirmModalLayout from "../../../layouts/ConfirmModalLayout";
import SidebarLayout from "../../../layouts/SidebarLayout";
import SuccessfullyModalLayout from "../../../layouts/SuccessfullyModalLayout";
import { formatDate, formatTime } from "../../../lib/time";
import { GetAllDisbursementDataType } from "../../../types/portal/disbursementPayment";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";

enum Status {
  "Success" = "status-success",
  "Failed" = "status-danger",
  "Pending" = "status-warning",
}

enum CurrentStage {
  "maker" = "status-dark",
  "checker" = "status-info",
  "approver" = "status-success",
}

export default function Disbursement() {
  const { id } = useParams();
  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [payrollStatus, setPayrollStatus] = useState("true");
  const { user, role } = useAppSelector((state) => state.auth);
  const [disbursementsPaymentChecker] =
    useDisbursementsPaymentCheckerMutation();
  const [isLoading, setIsLoading] = useState(false);
  const { keyword, handleInputChange } = useDebounce();
  const [disabled, setDisabled] = useState(false);

  const { page, limit, handlePagination, handleLimit, resetPagination } =
    useTable();
  // useTable(1, role === "checker" || role === "approver" ? 1000 : 10);
  const { open, handleOpen, handleClose } = useModal<
    undefined,
    "CONFIRM_FOR_APPROVAL"
  >();
  const {
    isLoading: isVendorLoading,
    isError: isVendorDetailsError,
    error: vendorDetailsError,
    data: vendorDetails,
    isFetching,
    refetch,
  } = useGetAllDisbursementsQuery({
    params: {
      disbursementBatchCode: id,
      company_id: user?.data?.company_id,
      permission: user?.data?.permission,
      page,
      limit,
      search: keyword,
    },
  });
  const {
    isError: isAmountError,
    error: amountError,
    // isLoading: isAmountLoading,
    data: amountData,
  } = useGetSalaryAmountQuery({
    params: {
      disbursementBatchCode: id,
      company_id: user?.data?.company_id,
      current_stage: "approver",
    },
  });
  const {
    isError: isDisbursementError,
    error: disbursementError,
    isLoading: isDisbursementLoading,
    data: disbursementData,
    refetch: refetchDisbursement,
  } = useCheckSalaryDisbursementQuery(
    {
      params: {
        disbursement_batch_code: String(id),
      },
    },
    {
      skip: role !== "approver",
    }
  );
  const [
    salaryPaymentWithOtp,
    {
      isError: isSalaryPaymentError,
      error: salaryPaymentError,
      isLoading: isSalaryPaymentLoading,
      isSuccess: isSalaryPaymentSuccess,
      data: salaryPaymentData,
    },
  ] = useDisbursementsPaymentWithOtpMutation();
  useError(isSalaryPaymentError, salaryPaymentError, "Salary payment fail");
  useError(isVendorDetailsError, vendorDetailsError, "Get payment data fail");
  useError(isAmountError, amountError, "Get amount data fail");
  useError(
    isDisbursementError,
    disbursementError,
    "Get disbursement data fail"
  );

  const vendorAllData = vendorDetails?.data?.data;

  const totalSelectedAmount = selectedData?.reduce(
    (acc, curr) => acc + curr?.amount || 0,
    0
  );

  const columns: ColumnsType<GetAllDisbursementDataType["data"]["data"][0]> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      width: 130,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      width: 130,
      render: (val) => (val ? `${formatDate(val)} ${formatTime(val)}` : "-"),
    },
    {
      title: "Amount (BDT)",
      dataIndex: "amount",
      width: 130,
      render: (val) => (val ? addCommaInNumber(val || 0) : "-"),
    },
    {
      title: "Employee ID",
      dataIndex: "employee_id",
      width: 100,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      width: 150,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Wallet Number",
      dataIndex: "wallet_number",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Current Stage",
      align: "center",
      dataIndex: "current_stage",
      render: (val: keyof typeof CurrentStage) => {
        // const capitalize = (str: string) =>
        //   str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "-";

        // const displayValue = capitalize(value || "-");

        // const status =
        //   role === "maker" && val === "maker"
        //     ? "Request Pending"
        //     : role === "checker" && val === "checker"
        //     ? "Request for Approval"
        //     : role === "approver" && val === "approver"
        //     ? "Paid"
        //     : "Pending";

        return (
          <span className={`status ${CurrentStage[val]}`}>
            {capitalize(val || "")}
          </span>
        );
      },
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      render: (value?: string) => {
        const displayValue = capitalize(
          value || "pending"
        ) as keyof typeof Status;

        return (
          <span className={`status ${Status[displayValue]}`}>
            {displayValue}
          </span>
        );
      },
    },
    // {
    //   title: "Action",
    //   align: "center",
    //   dataIndex: "id",
    //   render: (val) => (
    //     <Space size={8}>
    //       <Link
    //         to={`/admin/sheba-pay-wallet/payroll-disbursement-details/${val}`}
    //       >
    //         <Button
    //           type="default"
    //           size="small"
    //           className=" bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex justify-center items-center gap-0.5 overflow-hidden"
    //           icon={<OrangeEyeIcon />}
    //         >
    //           <span className="justify-start text-orange-500 text-sm font-medium font-['Inter'] leading-normal">
    //             Open
    //           </span>
    //         </Button>
    //       </Link>
    //     </Space>
    //   ),
    // },
  ];

  const handleSendToApprove = async () => {
    if (!selectedData?.length) return;

    setIsLoading(true);

    try {
      await Promise.all(
        selectedData
          .filter((el) => el?.id)
          .map((el) => disbursementsPaymentChecker({ id: el?.id }).unwrap())
      );

      toastMessage.success("Payment data sent successfully");
      setSelectedData([]);
      handleClose();
    } catch (error: any) {
      toastMessage.error(
        error?.data?.data?.message || "Failed to send payment data"
      );
    } finally {
      setIsLoading(false);
    }
  };

  // const handleApprover = async () => {
  //   if (!selectedData?.length) return;

  //   setIsLoading(true);

  //   try {
  //     await Promise.all(
  //       selectedData
  //         .filter((el) => el?.id)
  //         .map((el) =>
  //           disbursementsPayment({
  //             id: el?.id,
  //             data: {
  //               // sourceWalletPin: "972382",
  //               // amount: el?.amount,
  //               // sourceWallet: "8801111111122",
  //               // destinationWallet: "8801637740137",
  //               pin: pinNumber,
  //             },
  //           }).unwrap()
  //         )
  //     );

  //     // toast("success", "Payment approved successfully");
  //     toastMessage.success("Payment approved successfully");
  //     setSelectedData([]);
  //     handleClose();
  //   } catch (error: any) {
  //     // toast(
  //     //   "error",
  //     //   error?.data?.data?.message || "Failed to approved payment"
  //     // );
  //     toastMessage.error(
  //       error?.data?.data?.message || "Failed to approved payment"
  //     );
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (keyword) {
      resetPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  useEffect(() => {
    if (disabled) {
      setTimeout(() => {
        refetchDisbursement();
        setDisabled(false);
      }, 10000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  useEffect(() => {
    if (isSalaryPaymentSuccess) {
      refetchDisbursement();
      setDisabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSalaryPaymentSuccess]);

  return (
    <>
      <SidebarLayout
        title="Salary Disbursement"
        backLink="/admin/sheba-pay-wallet/disbursement"
      >
        {payrollStatus === "false" && (
          <Card style={{ width: "100%" }} className="p-5">
            <div className="flex items-center justify-center">
              <PayrollDisFileIcon />
            </div>

            <div className=" mt-6 text-center justify-center text-slate-600 text-sm font-normal font-['Inter'] leading-normal">
              Drag and drop your Excel file (.xlsx, .xls, .csv) here.
            </div>
            <div className=" mt-4 mb-4 text-center justify-center text-slate-600 text-sm font-normal font-['Inter'] leading-normal">
              Or
            </div>

            <div className="flex justify-center items-center">
              <Button
                onClick={() => handleOpen({ type: "IMPORT" })}
                type="default"
                className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                icon={
                  <div className="w-4 h-4 flex justify-center items-center">
                    <PayrollImportOutlined />
                  </div>
                }
              >
                <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                  Import
                </span>
              </Button>
            </div>
          </Card>
        )}

        {/* <Card style={{ width: "100%", marginBottom: "25px" }}>
          <div className="flex justify-between items-center">
            <div className="flex justify-start items-center gap-2">
              <img
                src={AvatarImage}
                alt="avatar-image"
                className="w-14 h-14 rounded-full"
              />
              <div className="ml-2">
                <div className="text-blue-500 text-lg font-semibold font-['Inter'] leading-normal">
                  M/S Enterprise
                </div>
                <p className="text-blue-500 text-sm font-medium font-['Inter'] leading-tight">
                  Wallet No: 01746398503
                </p>
              </div>
            </div>

            <BalanceSlide>10000BDT</BalanceSlide>
          </div>
        </Card> */}

        <CustomTable
          loading={isVendorLoading || isFetching}
          limit={limit}
          page={page}
          columns={columns}
          total={vendorDetails?.data?.count}
          dataSource={addKeyInArray(vendorAllData)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          // hideRowSelect
          rowSelection={
            //  || role === "approver"
            role === "checker"
              ? {
                  type: "checkbox",
                  selectedRowKeys: selectedData?.map((el) => el?.key),
                  onChange: (_, record) => {
                    setSelectedData(record as any[]);
                  },
                  getCheckboxProps: (record) => {
                    return role === "checker"
                      ? {
                          disabled: record?.current_stage !== "checker",
                        }
                      : role === "approver"
                      ? {
                          disabled:
                            record?.status === "pending" || !record?.status
                              ? false
                              : true,
                        }
                      : {};
                  },
                  columnWidth: 40,
                }
              : undefined
          }
          filterSection={
            <>
              {/*  || role === "approver" */}
              {role === "checker" ? (
                <div className="px-3 py-1 bg-[#F2F5FF] rounded-[100px] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-[#1B4DFF] text-base font-medium font-['Inter'] leading-7">
                    Total Amount: {addCommaInNumber(totalSelectedAmount || 0)}{" "}
                    BDT
                  </div>
                </div>
              ) : role === "approver" ? (
                <div className="px-3 py-1 bg-[#F2F5FF] rounded-[100px] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-[#1B4DFF] text-base font-medium font-['Inter'] leading-7">
                    Total Amount:{" "}
                    {addCommaInNumber(amountData?.data?.total_amount || 0)} BDT
                  </div>
                </div>
              ) : null}

              <Input
                suffix={<SearchIcon />}
                placeholder="Search by Vendor Id"
                onChange={(e) => handleInputChange(e)}
              />

              {/* {role === "maker" ? (
                <Button
                  onClick={() => handleOpen({ type: "IMPORT" })}
                  type="default"
                  className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                  icon={
                    <div className="w-4 h-4 flex justify-center items-center">
                      <PayrollImportOutlined />
                    </div>
                  }
                >
                  <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                    Import
                  </span>
                </Button>
              ) : null} */}

              {role === "checker" ? (
                <Button
                  className="middle-button min-w-[150px]"
                  type="primary"
                  disabled={!selectedData?.length}
                  onClick={() => handleOpen({ type: "CONFIRM" })}
                  loading={isLoading}
                >
                  Send to Approver
                </Button>
              ) : null}

              {role === "approver" ? (
                <Button
                  className="middle-button min-w-[150px]"
                  type="primary"
                  disabled={
                    isDisbursementLoading ||
                    disbursementData?.data?.result !== false ||
                    isVendorLoading ||
                    disabled
                  }
                  onClick={() => handleOpen({ type: "CONFIRM_FOR_APPROVAL" })}
                >
                  Approve
                </Button>
              ) : null}
            </>
          }
        />

        {/* {open?.type === "IMPORT" && (
          <DisbursementImportModal
            open={open.open}
            data={vendorDetails?.data?.count! + 1}
            handleClose={handleClose}

            // reRender={reRender}
            // uploadedCount={}
          />
        )} */}

        {open?.type === "SUCCESS" && (
          <SuccessfullyModalLayout
            title={<span>Successfully Uploaded!</span>}
            buttonName="View"
            buttonBgDeep={false}
            handleButton={handleClose}
            open={open?.open}
            handleClose={handleClose}
          />
        )}

        {open?.type === "CONFIRM" && (
          <ConfirmModalLayout
            title="Send to Approver"
            subTitle="Are you sure you want to send payment data to approver"
            buttonName="Send"
            handleButton={handleSendToApprove}
            open={open?.open}
            handleClose={handleClose}
            action
            buttonBgDeep
            loading={isLoading}
          />
        )}

        {open?.type === "CONFIRM_FOR_APPROVAL" && (
          <PinVerifyModal
            open={open?.open}
            handleClose={handleClose}
            refetch={refetch}
            isPaymentLoading={isSalaryPaymentLoading}
            isPaymentSuccess={isSalaryPaymentSuccess}
            paymentApi={(data) => {
              salaryPaymentWithOtp(data);
            }}
            paymentMessage={
              salaryPaymentData?.message || "Payment approved successfully"
            }
          />
          // <ConfirmModalLayout
          //   title="Approve"
          //   subTitle="Are you sure you want to approve payment"
          //   buttonName="Approved"
          //   handleButton={handleApprover}
          //   open={open?.open}
          //   handleClose={() => {
          //     handleClose();
          //     refetch();
          //     setSelectedData([]);
          //   }}
          //   action
          //   buttonBgDeep
          //   loading={isLoading}
          // >
          //   <Form.Item
          //     // label="Pin Number"
          //     name="pn"
          //     rules={[
          //       {
          //         required: true,
          //         message: "Please enter pin number",
          //       },
          //       {
          //         pattern: /^\d{6,}$/,
          //         message: "Pin number must be at least 6 digits",
          //       },
          //     ]}
          //   >
          //     <Input
          //       placeholder="Enter pin number"
          //       onChange={(e) => setPinNumber(e.target.value)}
          //     />
          //   </Form.Item>
          // </ConfirmModalLayout>
        )}
      </SidebarLayout>
    </>
  );
}

// type ApprovedModalProps = {
//   open: boolean;
//   handleClose: () => void;
//   refetch: () => void;
// };

// const ApprovedModal = ({ open, handleClose, refetch }: ApprovedModalProps) => {
//   const { id } = useParams();
//   const [sendOtp, { isError, error, isLoading, isSuccess, data }] =
//     useSendOtpMutation();
//   const [
//     vendorPaymentWithOtp,
//     {
//       isError: isVendorPaymentError,
//       error: vendorPaymentError,
//       isLoading: isVendorPaymentLoading,
//       isSuccess: isVendorPaymentSuccess,
//       data: vendorPaymentData,
//     },
//   ] = useDisbursementsPaymentWithOtpMutation();
//   useError(isError, error, "OTP send fail");
//   useError(isVendorPaymentError, vendorPaymentError, "Salary payment fail");
//   const { user } = useAppSelector((state) => state.auth);
//   const {
//     isLoading: isCompanyDetailsLoading,
//     isError: isCompanyDetailsError,
//     error: companyDetailsError,
//     data: companyDetails,
//   } = useGetSingleCompanyQuery(user?.data?.company_id, {
//     skip: !user?.data?.company_id,
//   });
//   useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");

//   let deviceId = localStorage.getItem("device_id");

//   const handleApprover = (values: any) => {
//     const newData = {
//       ...values,
//       sourceWallet: companyDetails?.data?.wallet_number,
//       App_Version: "4.1.0",
//       Device_Id: deviceId,
//       Device_Password: data?.data?.data?.Password,
//       FullName: "SP1A.210812.016",
//       LANG: "bn",
//       Os_Version: "12",
//       Phone_Brand: "itel S665L",
//       Phone_Os: "android",
//       Username: companyDetails?.data?.wallet_number,
//     };

//     vendorPaymentWithOtp({ id, data: newData });
//   };

//   useEffect(() => {
//     if (companyDetails?.data?.wallet_number)
//       sendOtp({
//         body: {
//           Username: companyDetails?.data?.wallet_number,
//           FullName: "SP1A.210812.016",
//           App_Version: "4.1.0",
//           Phone_Brand: "itel S665L",
//           Phone_Os: "android",
//           Os_Version: "12",
//           LANG: "bn",
//           Device_Id: deviceId,
//         },
//       });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [companyDetails?.data?.wallet_number]);

//   useEffect(() => {
//     if (isSuccess) toast.success("OTP send successfully");
//   }, [isSuccess]);

//   useEffect(() => {
//     if (isVendorPaymentSuccess) {
//       toast.success(
//         vendorPaymentData?.message || "Salary approved successfully"
//       );
//       refetch();
//       handleClose();
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isVendorPaymentSuccess]);

//   return (
//     <CustomModal
//       open={open}
//       handleClose={() => {
//         handleClose();
//         refetch();
//       }}
//       width={400}
//       footer={null}
//     >
//       <div className="flex items-center gap-2">
//         <span className="bg-[#FFF6ED] p-1 rounded">
//           <InfoIcon />
//         </span>
//         <span className="text-[22px] font-semibold">Approve</span>
//       </div>
//       {isCompanyDetailsLoading ? (
//         <Loader />
//       ) : !companyDetails?.data?.wallet_number ? (
//         <div>
//           <div className="mt-4 text-center justify-center text-red-600 text-sm font-normal leading-normal">
//             Wallet number not found, please set wallet number
//           </div>
//         </div>
//       ) : isLoading ? (
//         <Loader />
//       ) : (
//         <>
//           <div className="my-2 mt-3 text-[#5E718D]">
//             Are you sure you want to approve payment?
//           </div>
//           <Form
//             className="custom-form"
//             requiredMark="optional"
//             layout="vertical"
//             onFinish={handleApprover}
//           >
//             <Form.Item
//               label="OTP"
//               name="OTP"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please enter OTP",
//                 },
//                 {
//                   pattern: /^\d{6,}$/,
//                   message: "OTP must be at least 6 digits",
//                 },
//               ]}
//             >
//               <Input placeholder="Enter OTP" />
//             </Form.Item>
//             <Form.Item
//               label="Pin Number"
//               name="pin"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please enter pin number",
//                 },
//                 {
//                   pattern: /^\d{6,}$/,
//                   message: "Pin number must be at least 6 digits",
//                 },
//               ]}
//             >
//               <Input
//                 placeholder="Enter pin number"
//                 // onChange={(e) => setPinNumber(e.target.value)}
//               />
//             </Form.Item>
//             <Space className="w-full mt-3" size={12}>
//               <Button
//                 className="normal-dark-button modal-button"
//                 onClick={handleClose}
//                 size="middle"
//               >
//                 Cancel
//               </Button>
//               <Button
//                 className="modal-button"
//                 type="primary"
//                 htmlType="submit"
//                 size="middle"
//                 loading={isVendorPaymentLoading}
//               >
//                 Approved
//               </Button>
//             </Space>
//           </Form>
//         </>
//       )}
//     </CustomModal>
//   );
// };
